module.exports = __webpack_public_path__ + "assets/img/jd3.91f6b8e3.jpg";